import { Layer } from 'shared/map-exports';
import { usePoisState } from 'state/usePoisState';
import {
  getSelectedPatternStyle,
  getSelectedStrokeStyle,
} from 'features/mapping/mapping.utils';
import { MapClickGetPois } from 'features/mapping/mapping.types';
import { ResponsibilityAreaPoi } from 'features/mapping/components/dialogs/PoiDialog/PoiDialog.types';
import { getWatchdutyStaticTileUrl } from 'features/mapping/components/layers/layers.utils';
import { useStaticTileCacheDomain } from 'features/mapping/hooks/useStaticTileCacheDomain';
import { BELOW_STREETS_LAYER_ID } from 'features/mapping/styles/constants';
import { i18n } from 'i18n/config';
import { VisibilityToggledSource } from '../VisibilityToggledSource';
import { ResponsibilityArea } from './types';
import { layerFillStyle, layerStrokeStyle } from './layerStyles';
import {
  RESPONSIBILITY_AREAS_LAYER_ID,
  RESPONSIBILITY_AREAS_SOURCE_LAYER,
} from './constants';

type ResponsibilityAreasProps = {
  visible: boolean;
};

export const responsibilityAreaClickHandler: MapClickGetPois<
  ResponsibilityArea
> = (geoJsonFeatures) => {
  return geoJsonFeatures.map((feature) => {
    const responsibilityArea: ResponsibilityArea = feature.properties;
    const metadata: ResponsibilityAreaPoi = {
      title: i18n.t(`map.layers.responsibilityAreas.${responsibilityArea.SRA}`),
    };

    return {
      type: 'responsibilityArea',
      id: responsibilityArea.OBJECTID,
      metadata,
    };
  });
};

export const ResponsibilityAreasLayer = (
  props: ResponsibilityAreasProps,
): JSX.Element => {
  const { visible } = props;
  const { selectedPoi } = usePoisState();
  const staticTileCacheDomain = useStaticTileCacheDomain();

  const selectedId =
    (selectedPoi?.type === 'responsibilityArea' && selectedPoi.id!) || '';

  const selectedFillStyle = getSelectedPatternStyle({
    idKey: 'OBJECTID',
    otherLayerProps: { 'source-layer': RESPONSIBILITY_AREAS_SOURCE_LAYER },
    selectedId,
  });

  const selectedStrokeStyle = getSelectedStrokeStyle({
    idKey: 'OBJECTID',
    otherLayerProps: { 'source-layer': RESPONSIBILITY_AREAS_SOURCE_LAYER },
    selectedId,
  });

  return (
    <VisibilityToggledSource
      url={getWatchdutyStaticTileUrl(
        'ca_responsibility_area',
        staticTileCacheDomain,
      )}
      visible={visible}
    >
      <Layer
        id={RESPONSIBILITY_AREAS_LAYER_ID}
        beforeId={BELOW_STREETS_LAYER_ID}
        {...layerFillStyle}
      />
      <Layer beforeId={BELOW_STREETS_LAYER_ID} {...layerStrokeStyle} />
      <Layer beforeId={BELOW_STREETS_LAYER_ID} {...selectedFillStyle} />
      <Layer beforeId={BELOW_STREETS_LAYER_ID} {...selectedStrokeStyle} />
    </VisibilityToggledSource>
  );
};
